import axios from 'axios';
import router from '../../router/index';

export const Search = {
    namespaced: true,
    state: {
        search_results: [],
        search_promot_data: [],
        search_booking_dates: []
    },
    mutations: {
        searchComplete(state: any, data: any) {
            state.search_results = [];
            for (let i = 0; i < data.results.data.length; i++) {
                if (data.results.data[i].source.toLowerCase() === data.departure.toLowerCase() && data.results.data[i].destination.toLowerCase() === data.destination.toLowerCase()) {
                    state.search_results.push(data.results.data[i]);
                }
            }

            //redirect to search pages
            router.push('/search');

        },

        getAllBreakPoints(state: any) {
            let config ={
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem("jwt")
                }
            }
            
            let _ticketsapi = 'https://bookinga.herokuapp.com/api/v1/company/routes/breakpoints/all';
            
            axios.get(_ticketsapi, config)
                .then(response => {
                    if (response.data.data) {
                        if (response.data.data.length > 0) {
                            let lastIndex = response.data.data.length - 1;
                            if (response.data.data.length%2 == 0) {
                                for (let i = 0; i < response.data.data.length/2; i++) {
                                    if (!state.search_promot_data.includes(response.data.data[i].source)) {
                                        state.search_promot_data.push(response.data.data[i].source);
                                    }
                                    if (!state.search_promot_data.includes(response.data.data[i].destination)) {
                                        state.search_promot_data.push(response.data.data[i].destination);
                                    }
                                    if (!state.search_promot_data.includes(response.data.data[lastIndex].source)) {
                                        state.search_promot_data.push(response.data.data[lastIndex].source);
                                    }
                                    if (!state.search_promot_data.includes(response.data.data[lastIndex].destination)) {
                                        state.search_promot_data.push(response.data.data[lastIndex].destination);
                                    }
                                    lastIndex--;
                                }
                            } else {
                                let midIndex = (response.data.data.length/2)+1;
                                if (!state.search_promot_data.includes(response.data.data[midIndex].source)) {
                                    state.search_promot_data.push(response.data.data[midIndex].source);
                                }
                                if (!state.search_promot_data.includes(response.data.data[midIndex].destination)) {
                                    state.search_promot_data.push(response.data.data[midIndex].destination);
                                }

                                for (let i = 0; i < (response.data.data.length-1)/2; i++) {
                                    if (!state.search_promot_data.includes(response.data.data[i].source)) {
                                        state.search_promot_data.push(response.data.data[i].source);
                                    }
                                    if (!state.search_promot_data.includes(response.data.data[i].destination)) {
                                        state.search_promot_data.push(response.data.data[i].destination);
                                    }
                                    if (!state.search_promot_data.includes(response.data.data[lastIndex].source)) {
                                        state.search_promot_data.push(response.data.data[lastIndex].source);
                                    }
                                    if (!state.search_promot_data.includes(response.data.data[lastIndex].destination)) {
                                        state.search_promot_data.push(response.data.data[lastIndex].destination);
                                    }
                                    lastIndex--;
                                }
                            }
                        }
                    }
                }).catch((err) => {})
        },

        generateBookingDates(state: any, tickets: any) {
            console.log("called")
            if (tickets != undefined && tickets[0].length > 0) {
                let lastIndex = tickets[0].length - 1;
                if (((tickets[0].length)%2) == 0) {
                    for (let i = 0; i < tickets[0].length/2; i++) {
                        if (!state.search_booking_dates.includes(tickets[0][i].date.split("T")[0])) {
                            state.search_booking_dates.push(tickets[0][i].date.split("T")[0]);
                        }
                       
                        if (!state.search_booking_dates.includes(tickets[0][lastIndex].date.split("T")[0])) {
                            state.search_booking_dates.push(tickets[0][lastIndex].date.split("T")[0]);
                        }
                        lastIndex--;
                    }
                } else {
                    let midIndex = (((tickets[0].length)-1)/2)+1;
                    if (!state.search_booking_dates.includes(tickets[0][midIndex].date.split("T")[0])) {
                        state.search_booking_dates.push(tickets[0][midIndex].date.split("T")[0]);
                    }

                    for (let i = 0; i < ((tickets[0].length)-1)/2; i++) {
                        if (!state.search_booking_dates.includes(tickets[0][i].date.split("T")[0])) {
                            state.search_booking_dates.push(tickets[0][i].date.split("T")[0]);
                        }

                        if (!state.search_booking_dates.includes(tickets[0][lastIndex].date.split("T")[0])) {
                            state.search_booking_dates.push(tickets[0][lastIndex].date.split("T")[0]);
                        }
                        lastIndex--;
                    }
                }
            }
        }
    },
    actions: { 

    },
    getters: {},
    modules: {}
}